<template>
  <div class="info-wrapper-item">
    <slot></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.info-wrapper-item {
  @include body-smaller;
}

.info-wrapper-item>:first-child {
  @include body-smaller-bold;
}
</style>
